import api from '@/services/api'
import Competition from '@/models/competition'
import moment from '@/utils/moment'

export default {
  namespaced: true,
  state: {
    _competitions: [],
    _competition: null,
    termsAndConditions: null
  },
  getters: {
    competition: (state, getters, rootState, rootGetters) => {
      const { id: brandId } = rootGetters['app/BRAND']
      if (state._competition && state._competition.brands.includes(brandId)) {
        return state._competition
      }
      return null
    },
    currentBrandCompetitions: (state, getters, rootState, rootGetters) => {
      const { id: brandId } = rootGetters['app/BRAND']

      const activeCompetitions = state._competitions
        .filter(c => c.brands.includes(brandId))
        .filter(c => moment().isAfter(c.dateStart))
        .filter(c => moment().isBefore(c.dateStop))

      const hasPriority = competition => competition.meta.priorities && competition.meta.priorities[brandId] !== undefined

      const prioritizedCompetitions = activeCompetitions
        .filter(competition => hasPriority(competition))
        .sort((a, b) => -(b.meta.priorities[brandId] - a.meta.priorities[brandId]))

      const notPrioritizedCompetitions = activeCompetitions.filter(competition => !hasPriority(competition))

      return [...prioritizedCompetitions, ...notPrioritizedCompetitions]
    }
  },
  mutations: {
    setCompetitions (state, data) {
      state._competitions = data.map(c => new Competition(c))
    },
    setCompetition (state, data) {
      state._competition = new Competition(data)
    },
    clearCompetition (state) {
      state._competition = null
    },
    setTermsAndConditions (state, data) {
      state.termsAndConditions = data.html
    }
  },
  actions: {
    async loadList ({ commit }) {
      const data = await api.competitions.loadList()
      commit('setCompetitions', data)
    },
    async loadDetails ({ commit }, competitionId) {
      const data = await api.competitions.loadDetails(competitionId)
      commit('setCompetition', data)
    },
    async loadPreview ({ commit }, payload) {
      const { competitionId, updatedAt } = payload
      const data = await api.competitions.loadPreview(competitionId, updatedAt)
      commit('setCompetition', data)
    },
    async loadTermsAndConditions ({ commit }, competitionId) {
      const data = await api.competitions.loadTermsAndConditions(competitionId)
      commit('setTermsAndConditions', data)
    }
  }
}
